import { Injectable } from '@angular/core';
import { getLastValueSync, OccEndpointsService } from '@spartacus/core';
import {
  BehaviorSubject,
  combineLatest,
  filter,
  first,
  map,
  Observable,
  of,
  Subject,
  switchMap,
} from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { ExcelDownloadService } from '../shared/services/excel-download.service';
import { SharedService } from '../shared/services/shared.service';
import { ActiveSeasons, FLU_CHECKOUT_TYPE } from '../shared/model/flu.model';
import { HttpClient } from '@angular/common/http';
import { LocationStripService } from '../shared/modules/location-strip/location-strip.service';
import {
  CUSTOM_ORDER_TYPE,
  CustomQuotesList,
  CustomUser,
  OrderItem,
  RESERVATION_ACTION_TYPE,
  ReservationItem,
} from '../shared/model';
import { Order } from '@spartacus/order/root';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { ACTIVE_SEASONS, UserUtils } from '../shared';
import { Router } from '@angular/router';
import { CustomAddToCartService } from '../custom-add-to-cart/custom-add-to-cart.service';
import { Voucher } from '@spartacus/cart/base/root';
import { DataLayerService } from '../shared/modules/data-layer';
import { DATA_LAYER_PROCESS_TYPES } from '../shared/modules/data-layer/constants/data-layer.constants';

@Injectable({
  providedIn: 'root',
})
export class CustomInfluenzaService {
  activeSeasons = new BehaviorSubject<ActiveSeasons[]>(null);
  activetab: any;
  fluProducts: any;
  addedProductsToCart: any;
  userIdOfLoggedInUser: any;
  activeCartId: any;
  cartDlete: any;
  itemDlete: any;
  contiueShopping = false;
  updateFluCart: any;
  ordersHistory: any;
  cartType: any;
  dataForExcel: any;
  updatedInfContact: any;
  reservationDetails$ = new BehaviorSubject<ReservationItem>(null);
  cartIdActiveOfUser: any;
  createCartOfUser: any;
  changedLocation: any;
  removedFluCartItems: any;
  checkoutInfluenza = new Subject();
  defaultFields = '?fields=DEFAULT';
  getVolumePrices: any;
  allFluOrders = new BehaviorSubject<Order[]>(null);
  allReservations = new BehaviorSubject<OrderItem[]>([]);

  constructor(
    private readonly baseService: BaseService,
    private readonly router: Router,
    private readonly sharedService: SharedService,
    public excelService: ExcelDownloadService,
    protected http: HttpClient,
    protected occEndPointsService: OccEndpointsService,
    protected locService: LocationStripService,
    protected userService: UserAccountFacade,
    protected occEndpointsService: OccEndpointsService,
    protected userFacade: UserAccountFacade,
    protected addToCart: CustomAddToCartService,
    protected dataLayerService: DataLayerService
  ) {
    this.activetab = new Subject();
    this.fluProducts = new Subject();
    this.addedProductsToCart = new Subject();
    this.userIdOfLoggedInUser = new Subject();
    this.activeCartId = new Subject();
    this.cartDlete = new Subject();
    this.itemDlete = new Subject();
    this.updateFluCart = new Subject();
    this.ordersHistory = new Subject();

    this.updatedInfContact = new Subject();
    this.cartIdActiveOfUser = new Subject();
    this.createCartOfUser = new Subject();
    this.changedLocation = new Subject();
    this.removedFluCartItems = new Subject();
    this.getVolumePrices = new Subject();
  }

  getFluCheckoutType(): Observable<FLU_CHECKOUT_TYPE> {
    return of(FLU_CHECKOUT_TYPE.INDIRECT);
  }

  public removedFluCartEntries(cartId, userId) {
    this.baseService
      .get(
        'users/' +
          userId +
          '/carts/' +
          cartId +
          '?cartPage=true&fields=DEFAULT&standardCart=false'
      )
      .subscribe((res) => {
        if (res) {
          this.removedFluCartItems.next(res);
        }
      });
  }
  public updateShipToId(userId, cartId, shipToUnitId, standardCart) {
    this.baseService
      .post(
        '/users/' +
          userId +
          '/carts/' +
          cartId +
          '/addShipToUnit/' +
          shipToUnitId +
          '/' +
          standardCart +
          this.defaultFields,
        {}
      )
      .subscribe((res) => {
        if (res) {
          this.changedLocation.next(true);
        }
      });
  }

  public getCartIdofUser(userId) {
    this.baseService
      .get(
        '/users/' +
          userId +
          '/carts?currentPage=0&fields=DEFAULT&pageSize=20&savedCartsOnly=false'
      )
      .subscribe((res) => {
        if (res) {
          this.cartIdActiveOfUser.next(res);
        }
      });
  }
  public createCartIdofUser(userId) {
    this.baseService
      .post('users/' + userId + '/carts?fields=DEFAULT', {})
      .subscribe((res) => {
        if (res) {
          this.addToCart.allCartItems.next({ carts: [res] });
        }
      });
  }
  public getVolumePrice(products) {
    this.userFacade.get().subscribe((customer: any) => {
      if (customer) {
        this.baseService
          .post(
            `/products/getPrice?fields=DEFAULT&emulatedUser=${customer.userName}`,
            products
          )
          .subscribe((res) => {
            if (res) {
              this.getVolumePrices.next(res);
            }
          });
      }
    });
  }

  public getActiveSeasonsFromDb(userId) {
    if (!this.activeSeasons.getValue()) {
      this.baseService
        .get('users/' + userId + '/influenza/get-active-seasons')
        .subscribe((res) => {
          if (res) {
            this.activeSeasons.next(res.categoryData);
            this.sharedService.setSessionStorage(
              ACTIVE_SEASONS,
              res.categoryData?.[0]?.code
            );
          }
        });
    }
  }
  public getUserOrderHistory(userId, seasonId) {
    this.baseService
      .get(
        'users/' +
          userId +
          '/orders?currentPage=0&fields=DEFAULT&orderType=ZPRE&seasonId=' +
          seasonId
      )
      .subscribe((res) => {
        if (res) {
          this.ordersHistory.next(res);
        }
      });
  }
  public getFluProducts(userId, seasonId) {
    const isPBI = this.sharedService.getSessionStorage('PBI');
    this.fluProducts.next(false);
    const url = this.occEndPointsService.buildUrl(
      isPBI ? 'getFluProductsPBI' : 'getFluProducts',
      {
        urlParams: { userId: userId, seasonId: seasonId },
      }
    );
    this.http.get(url).subscribe((res) => {
      if (res) {
        this.fluProducts.next(res);
      }
    });
  }

  public addFluProductsToCart(userId, cartId, params) {
    this.baseService
      .post(
        'users/' + userId + '/carts/' + cartId + '/bulk-add-to-cart',
        params
      )
      .subscribe({
        next: (res) => {
          if (res) {
            this.addedProductsToCart.next(res);
          }
        },
        error: (err) => {
          this.addedProductsToCart.next(err);
        },
      });
  }
  public updateFluProductsToCart(userId, parentCartId, childCartId, params) {
    this.baseService
      .patch(
        'users/' +
          userId +
          '/carts/' +
          parentCartId +
          '/update/' +
          childCartId +
          this.defaultFields,
        params
      )
      .subscribe({
        next: (res) => {
          if (res) {
            this.updateFluCart.next(res);
          }
        },
        error: (err) => {
          this.updateFluCart.next(err);
        },
      });
  }
  public deleteEntireCart(userId, childCartId) {
    this.baseService
      .delete('users/' + userId + '/carts/' + childCartId)
      .subscribe(() => {
        this.cartDlete.next(true);
      });
  }
  public deleteCartItems(userId, parentCartId, entryNumber, childCartId) {
    this.baseService
      .delete(
        'users/' +
          userId +
          '/carts/' +
          parentCartId +
          '/entries/' +
          entryNumber +
          '/' +
          childCartId
      )
      .subscribe(() => {
        this.itemDlete.next(true);
      });
  }
  public downloadXls(data, name) {
    this.excelService.exportAsExcelFile(data, name, true);
  }

  public checkoutItems(userId, cartId, params) {
    this.checkoutInfluenza.next(false);
    this.baseService
      .post(
        'users/' +
          userId +
          '/carts/' +
          cartId +
          '/orderSimulate?fields=DEFAULT',
        params
      )
      .subscribe({
        next: (res) => {
          if (res) {
            this.checkoutInfluenza.next(res);
          }
        },
        error: (err) => {
          this.checkoutInfluenza.next(err);
        },
      });
  }
  updateContact(params, userId): void {
    this.baseService
      .put('users/' + userId + '/influenza/updateContactInfo', params)
      .subscribe((res) => {
        if (res) {
          this.locService.getUserAccountDataFromDb(userId);
        }
      });
  }

  public getAllFluOrders(): void {
    this.userService
      .get()
      .pipe(
        filter(Boolean),
        switchMap((user: CustomUser) => {
          const url = this.occEndPointsService.buildUrl('getOrderHistory', {
            urlParams: {
              userId: user?.uid,
            },
            queryParams: {
              orderType: CUSTOM_ORDER_TYPE.ZPRE,
            },
          });
          return UserUtils.isPharmacyUser(user)
            ? this.http
                .get<Order[]>(url)
                .pipe(
                  map((res: any) => (res.orders.length ? res.orders : null))
                )
            : of(null);
        })
      )
      .subscribe((res) => {
        this.allFluOrders.next(res);
      });
  }

  getAllReservations(): void {
    this.userService
      .get()
      .pipe(first(Boolean), map(UserUtils.isPharmacyUser))
      .subscribe((isPharmacy) => {
        const userId = getLastValueSync(this.userFacade.get()).uid;
        const url = this.occEndPointsService.buildUrl(
          isPharmacy
            ? 'getAllReservationsPharmacy'
            : 'getAllReservationsPhysician',
          {
            urlParams: {
              userId,
            },
          }
        );
        this.http.get<CustomQuotesList>(url).subscribe((res) => {
          if (res) {
            const quotes = res.quotes.length ? [...res.quotes].reverse() : null;
            this.allReservations.next(quotes);
          }
        });
      });
  }

  getReservationDetails(reservationCode: string): void {
    this.userFacade
      .get()
      .pipe(first(Boolean))
      .subscribe((user) => {
        const userId = user?.uid;
        const url = this.occEndPointsService.buildUrl('getReservationDetails', {
          urlParams: {
            userId,
            reservationCode,
          },
        });
        this.http.get<ReservationItem>(url).subscribe((res) => {
          if (res) {
            this.reservationDetails$.next(res);
          }
        });
      });
  }

  setReservationStatus(
    actionType: RESERVATION_ACTION_TYPE,
    reservationDetails: ReservationItem
  ): void {
    const quoteCode = reservationDetails?.code;
    const urlMapping = {
      [RESERVATION_ACTION_TYPE.APPROVE]: 'approveReservation',
      [RESERVATION_ACTION_TYPE.REJECT]: 'rejectReservation',
      [RESERVATION_ACTION_TYPE.AKNOWLEDGE]: 'aknowledgeReservation',
      [RESERVATION_ACTION_TYPE.CANCEL]: 'cancelReservation',
    };
    const userId = getLastValueSync(this.userService.get()).uid;
    const url = this.occEndPointsService.buildUrl(urlMapping[actionType], {
      urlParams: {
        userId,
        quoteCode,
      },
    });
    this.http.post(url, {}).subscribe(() => {
      if (actionType === RESERVATION_ACTION_TYPE.APPROVE) {
        this.dataLayerService.purchase({
          ...reservationDetails,
          processType: DATA_LAYER_PROCESS_TYPES.CONFIRM_RESERVATION,
        });
      }
      this.getReservationDetails(quoteCode);
    });
  }

  editReservation(quoteCode: string): Observable<any> {
    return this.userService.get().pipe(
      first(Boolean),
      switchMap((user: CustomUser) => {
        return this.http.put<Order>(
          this.occEndPointsService.buildUrl('editReservation', {
            urlParams: {
              userId: user?.uid,
              quoteCode,
            },
          }),
          {}
        );
      })
    );
  }

  sanitizeFluCart(
    userId,
    params?: {
      isEdit?: boolean;
    }
  ): Observable<any> {
    const url = this.occEndPointsService.buildUrl('sanitizeCart', {
      urlParams: {
        userId,
      },
      queryParams: {
        isEdit: params?.isEdit,
      },
    });
    return this.http.post(url, {});
  }

  getEditFluPreOrderConfig(userId: string, orderId: string): Observable<any> {
    const url = this.occEndPointsService.buildUrl('fluOrderUpdateDetails', {
      urlParams: {
        userId,
        orderId,
      },
    });
    return this.http.get(url);
  }

  getFluPreOrderUpdate(userId: string, orderCode: string): Observable<any> {
    const url = this.occEndPointsService.buildUrl('fluOrderUpdate', {
      urlParams: {
        userId,
        orderCode,
      },
    });
    const newOrderCode = {
      code: orderCode,
    };
    return this.http.post(url, newOrderCode);
  }

  getPharmacyAssociation(): Observable<Voucher[]> {
    return combineLatest([
      this.userService.get(),
      this.addToCart.activeFluCart$,
    ]).pipe(
      first(([user, cart]) => !!user && !!cart),
      switchMap(([user, cart]) => {
        const url = this.occEndPointsService.buildUrl('pharmacyAssociation', {
          urlParams: {
            userId: user.uid,
            cartId: cart.code,
          },
        });
        return this.http.get(url).pipe(
          map((response: { vouchers: Voucher[] }) => {
            return response?.vouchers || [];
          })
        );
      })
    );
  }

  setPharmacyAssociation(voucherId: string): Observable<any> {
    return combineLatest([
      this.userService.get(),
      this.addToCart.activeFluCart$,
    ]).pipe(
      first(([user, cart]) => !!user && !!cart),
      switchMap(([user, cart]) => {
        const url = this.occEndPointsService.buildUrl('pharmacyAssociation', {
          urlParams: {
            userId: user.uid,
            cartId: cart.code,
          },
          queryParams: {
            voucherId,
          },
        });
        return this.http.post(url, {});
      })
    );
  }
}
